import moment from 'moment'
import session from '@/auth/session'
import { getUserSubscription, getPromoterCode } from '@/utils/tokenUtils'

export default {
  getMessage(field, args) {
    return field
  },
  validate(value, args) {
    if (session.isApiLogin() && getPromoterCode() === '2038' && getUserSubscription() === 'FREE') {
      let _value = moment(value, 'DD/MM/YYYY', true)
      let _valueMinus3 = moment().subtract(3, 'months')
      return _value.isAfter(_valueMinus3)
    }
    return true
  }
}
